import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ResetStatusService {

  constructor(private httpClient: HttpClient) {
  }

  public ResetStatus(claimId: number) {
    return this.httpClient.put(`${environment.apiServer}/Adjuster/Claim/ResetStatus?claimId=${claimId}`, null);
  }

}
